// Status pill — tinted background. STATUS_COLORS holds the seed
// palette for the 7 canonical statuses so the badge renders before
// the catalogue fetch resolves and as a fallback for any label
// missing from the catalogue (e.g. a status that was archived after
// the job adopted it). The live catalogue takes precedence via
// useStatusByLabel so renames + recolours surface immediately.
import { useStatusByLabel } from "./JobStatusesProvider";
import type { JobStatus } from "../../../../../../shared/types/production-schedule";

export const STATUS_COLORS: Record<string, string> = {
  New: "#7C3AED",
  Scheduled: "#1B449C",
  "In Progress": "#2E7D32",
  Review: "#2453B5",
  IFA: "#C77700",
  Complete: "#707372",
  Cancelled: "#B3261E",
};

const FALLBACK_COLOR = "#707372";

interface Props {
  status: JobStatus;
  // Optional explicit override — when the caller has the row in hand
  // (BoardView columns build directly off the catalogue), pass the
  // colour to skip the lookup.
  color?: string;
}

export function StatusBadge({ status, color }: Props) {
  const lookup = useStatusByLabel();
  const c = color ?? lookup(status)?.color ?? STATUS_COLORS[status] ?? FALLBACK_COLOR;
  return (
    <span
      className="status-badge"
      style={{ background: `${c}22`, color: c }}
    >
      {status}
    </span>
  );
}
